import { Methods } from '@newview/infrastructure';
import { DbCenterBaseApi } from "../DbCenterBaseApi";

export class DbGrayfieldApi extends DbCenterBaseApi {

    public get ControllerName(): any {
        return 'dbGrayfield';
    }

    /**
     * 获取表字段
     * @param tableId 
     * @returns 
     */
    public getDbFieldByTableId(tableId) {
        return this.send({ tableId }, 'getDbFieldByTableId', Methods.GET);
    }

    /**
     * 根据Dev字段获取灰度字段
     * @param devFieldId 
     * @returns 
     */
    public getDbFieldByDevFieldId(devFieldId) {
        return this.send({ devFieldId }, "getDbFieldByDevFieldId", Methods.GET);
    }

}